import { render, staticRenderFns } from "./NoticeTitle.vue?vue&type=template&id=6f431c75&scoped=true"
import script from "./NoticeTitle.vue?vue&type=script&lang=ts"
export * from "./NoticeTitle.vue?vue&type=script&lang=ts"
import style0 from "./NoticeTitle.vue?vue&type=style&index=0&id=6f431c75&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f431c75",
  null
  
)

export default component.exports